"use strict";

var _interopRequireWildcard = require("/Volumes/Untitled/project/050/050admin/node_modules/@babel/runtime/helpers/interopRequireWildcard.js");
var _interopRequireDefault = require("/Volumes/Untitled/project/050/050admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.string.iterator");
require("core-js/modules/es6.function.name");
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.regexp.replace");
require("core-js/modules/es7.array.includes");
require("core-js/modules/es6.string.includes");
var _regeneratorRuntime2 = _interopRequireDefault(require("/Volumes/Untitled/project/050/050admin/node_modules/@babel/runtime-corejs2/helpers/regeneratorRuntime.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/Volumes/Untitled/project/050/050admin/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _objectSpread2 = _interopRequireDefault(require("/Volumes/Untitled/project/050/050admin/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
require("core-js/modules/es6.number.constructor");
var _vuex = require("vuex");
var enumConst = _interopRequireWildcard(require("@/utils/enum"));
var food = _interopRequireWildcard(require("@/api/food"));
var menuFood = _interopRequireWildcard(require("@/api/menu-food"));
var _Gallery = _interopRequireDefault(require("./Gallery.vue"));
var _Variant = _interopRequireDefault(require("./Variant.vue"));
var _foodVariation = require("@/api/foodVariation");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  components: {
    Gallery: _Gallery.default,
    Variant: _Variant.default
  },
  props: {
    dialogDisabled: {
      type: Boolean,
      default: false
    },
    storeId: Number,
    type: String
  },
  computed: (0, _objectSpread2.default)((0, _objectSpread2.default)({}, (0, _vuex.mapGetters)(["token"])), (0, _vuex.mapState)({
    menuData: function menuData(state) {
      return state.menuFood.list;
    }
  })),
  data: function data() {
    return {
      activeName: "info",
      isCopy: false,
      dialogLoading: false,
      tempData: {},
      dialogStatus: "",
      dialogVisible: false,
      loadingButton: false,
      baseUrl: process.env.VUE_APP_BASE_API,
      baseUrlMedia: process.env.VUE_APP_BASE_URL_MEDIA,
      STORE_TYPE: enumConst.STORE_TYPE,
      menuFoodList: [],
      menuFoodListQuery: {
        page: 1,
        limit: 100
      },
      rules: {
        name: {
          required: true,
          message: "Vui lòng nhập tên món",
          trigger: "submit"
        },
        originPrice: {
          required: true,
          message: "Vui lòng nhập giá gốc",
          trigger: "submit"
        },
        // finalPrice: {
        //   required: true,
        //   message: "Vui lòng nhập giá bán",
        //   trigger: "submit"
        // },
        // thumbnail: {
        //   required: true,
        //   message: "Vui lòng chọn ảnh",
        //   trigger: "submit",
        // },
        menuFoodId: {
          required: true,
          message: "Vui lòng chọn danh mục",
          trigger: "submit"
        }
      }
    };
  },
  methods: {
    fetchCategory: function () {
      var _fetchCategory = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee() {
        var _yield$menuFood$findA, data;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!this.storeId) {
                _context.next = 8;
                break;
              }
              _context.next = 3;
              return menuFood.findAll((0, _objectSpread2.default)((0, _objectSpread2.default)({}, this.menuFoodListQuery), {}, {
                storeId: this.storeId
              }));
            case 3:
              _yield$menuFood$findA = _context.sent;
              data = _yield$menuFood$findA.data;
              this.menuFoodList = data.menuFoods;
              _context.next = 9;
              break;
            case 8:
              this.menuFoodList = [];
            case 9:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function fetchCategory() {
        return _fetchCategory.apply(this, arguments);
      }
      return fetchCategory;
    }(),
    handleUploadSuccess: function handleUploadSuccess(res, file) {
      this.dialogLoading = false;
      this.$set(this.tempData, "thumbnail", res.data.path);
    },
    beforeUpload: function beforeUpload(file) {
      this.dialogLoading = true;
      var isJPG = file.type.includes("image");
      var isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        this.dialogLoading = false;
        this.$message.error("Chỉ chấp nhận ảnh dưới 2MB");
      }
      if (!isJPG) {
        this.dialogLoading = false;
        this.$message.error("Avatar picture must be image format!");
      }
      return isJPG && isLt2M;
    },
    editData: function editData() {
      var _this = this;
      var gallery = [];
      if (this.type == "OTHER") {
        gallery = this.$refs.gallery.fileList.map(function (e) {
          return e.response ? e.response.data.path : e.url.replace(_this.baseUrlMedia, "");
        });
      }
      this.$refs["dataForm"].validate(function (valid) {
        if (valid) {
          var data = {
            food: (0, _objectSpread2.default)((0, _objectSpread2.default)({}, _this.tempData), {}, {
              thumbnail: _this.tempData.thumbnail,
              //Không truyền foodVariationGroupName vì đã tách ra cấu hình bên khác
              foodVariationGroupName: undefined
            }),
            menuFoodId: _this.tempData.menuFoodId,
            galleries: gallery
          };
          _this.loadingButton = true;
          food.update(_this.tempData.id, data).then(function (res) {
            if (res.status) {
              _this.$notify({
                type: "success",
                message: "Cập nhật món thành công"
              });
              _this.dialogVisible = false;
              _this.$emit("update:success");
            }
          }).finally(function () {
            _this.loadingButton = false;
          });
        }
      });
    },
    onUpdateSuccess: function onUpdateSuccess() {
      this.$emit("update:success");
    },
    handleEdit: function handleEdit(data) {
      var _this2 = this;
      this.activeName = "info";
      this.dialogStatus = "edit";
      this.isCopy = false;
      this.dialogVisible = true;
      this.menuFoodListQuery.search = "";
      this.fetchCategory();
      this.$nextTick(function () {
        _this2.$refs["dataForm"].clearValidate();
        _this2.tempData = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, data), {}, {
          menuFoodId: data.menuFood && data.menuFood.id
        });
        console.log("data food", _this2.tempData);
        if (_this2.type == "OTHER") {
          _this2.$refs.gallery.fileList = data.foodGalleries.map(function (e) {
            return {
              url: _this2.$url(e.thumbnail)
            };
          });
        }
      });
    },
    handleCopy: function handleCopy(data) {
      var _this3 = this;
      this.activeName = "info";
      this.dialogStatus = "add";
      this.isCopy = true;
      this.dialogVisible = true;
      this.menuFoodListQuery.search = "";
      this.fetchCategory();
      this.$nextTick(function () {
        _this3.$refs["dataForm"].clearValidate();
        _this3.tempData = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, data), {}, {
          menuFoodId: data.menuFood && data.menuFood.id
        });
        console.log("data food", _this3.tempData);
        if (_this3.type == "OTHER") {
          _this3.$refs.gallery.fileList = data.foodGalleries.map(function (e) {
            return {
              url: $url(e.thumbnail)
            };
          });
        }
      });
    },
    handleAdd: function handleAdd() {
      var _this4 = this;
      this.activeName = "info";
      this.dialogVisible = true;
      this.isCopy = false;
      this.dialogStatus = "add";
      this.menuFoodListQuery.search = "";
      this.fetchCategory();
      this.$nextTick(function () {
        _this4.$refs["dataForm"].resetFields();
        _this4.tempData = {
          type: "",
          openTime: "",
          closeTime: "",
          lat: 0,
          long: 0
        };
        if (_this4.type == "OTHER") {
          _this4.$refs.gallery.fileList = [];
        }
      });
    },
    createData: function createData() {
      var _this5 = this;
      var galleries = [];
      if (this.type == "OTHER") {
        var gallery = this.$refs["gallery"].fileList;
        galleries = gallery.map(function (e) {
          return e.response ? e.response.data.path : e.url.replace(_this5.baseUrlMedia, "");
        });
      }
      this.$refs["dataForm"].validate(function (valid) {
        if (valid) {
          if (!_this5.tempData.finalPrice) {
            _this5.tempData.finalPrice = _this5.tempData.originPrice;
          }
          var data = {
            food: (0, _objectSpread2.default)((0, _objectSpread2.default)({}, _this5.tempData), {}, {
              thumbnail: _this5.tempData.thumbnail
            }),
            storeId: _this5.storeId,
            menuFoodId: _this5.tempData.menuFoodId,
            galleries: galleries
          };
          _this5.loadingButton = true;
          food.create(data).then( /*#__PURE__*/function () {
            var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee2(res) {
              return (0, _regeneratorRuntime2.default)().wrap(function _callee2$(_context2) {
                while (1) switch (_context2.prev = _context2.next) {
                  case 0:
                    if (!res.status) {
                      _context2.next = 8;
                      break;
                    }
                    if (!_this5.isCopy) {
                      _context2.next = 4;
                      break;
                    }
                    _context2.next = 4;
                    return _this5.copyData(res.data.id);
                  case 4:
                    _this5.$notify({
                      type: "success",
                      message: "Tạo món thành công"
                    });
                    _this5.dialogVisible = false;
                    _this5.$refs["dataForm"].clearValidate();
                    _this5.$emit("create:success");
                  case 8:
                  case "end":
                    return _context2.stop();
                }
              }, _callee2);
            }));
            return function (_x) {
              return _ref.apply(this, arguments);
            };
          }()).finally(function () {
            _this5.loadingButton = false;
          });
        }
      });
    },
    copyData: function () {
      var _copyData = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee3(foodId) {
        var promiseArr;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              if (this.tempData.foodVariations) {
                _context3.next = 2;
                break;
              }
              return _context3.abrupt("return");
            case 2:
              promiseArr = [];
              this.tempData.foodVariations.filter(function (item) {
                return !item.isDeleted;
              }).forEach(function (item, index) {
                var dataPost = {
                  foodVariation: {
                    name: item.name,
                    price: item.price,
                    position: index
                  },
                  foodId: foodId
                };
                promiseArr.push((0, _foodVariation.postVariant)(dataPost));
              });
              _context3.next = 6;
              return Promise.all(promiseArr);
            case 6:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function copyData(_x2) {
        return _copyData.apply(this, arguments);
      }
      return copyData;
    }()
  }
};